module.exports = __webpack_public_path__ + "static/img/head.906151b.png";


//////////////////
// WEBPACK FOOTER
// ./static/head.png
// module id = OCpg
// module chunks = 1